import PropTypes from 'prop-types';
import React from 'react';

const ZomatoGiftCard = ({
  imageUrl,
  userMessage,
  formattedAmount,
  companyName,
  claimLink,
  gcCode,
  gcPin,
}) => (
  <div
    style={{
      transform: 'scale(0.78)', // Scaling down to half
      transformOrigin: 'top left', // Adjust as needed
      fontFamily: "'Our Lexend', Arial, sans-serif",
      backgroundColor: '#E23744',
      color: '#333',
      padding: '0',
      margin: '0',
      border: '10px solid white',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      width: '400px',
      borderRadius: '20px',
    }}
  >
    <table
      style={{
        backgroundColor: '#E23744',
        maxWidth: '355px',
        borderSpacing: '0',
        margin: '0 auto',
        textAlign: 'center',
        padding: '0',
      }}
    >
      <tbody>
        {/* Header Section */}
        <tr>
          <td
            colSpan='2'
            style={{
              backgroundColor: '#E23744',
              padding: '15px',
              color: 'white',
              textAlign: 'center',
            }}
          >
            <h1
              style={{
                fontSize: '28px',
                fontWeight: '600',
                letterSpacing: '-0.56px',
                margin: '0',
                color: 'white',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Here&apos;s your
            </h1>
            <h1
              style={{
                fontSize: '28px',
                fontWeight: '600',
                letterSpacing: '-0.56px',
                margin: '0 0 10px 0',
                color: 'white',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Zomato Gift Card!
            </h1>
            <h1
              style={{
                fontSize: '18px',
                fontWeight: '400',
                letterSpacing: '-0.56px',
                margin: '0',
                color: 'white',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              from 
              {' '}
              {companyName}
            </h1>
          </td>
        </tr>
        {/* Gift Card Section */}
        <tr>
          <td colSpan='2'>
            <table
              style={{
                width: '100%',
                backgroundColor: '#FFF',
                borderRadius: '8px',
                margin: '0',
                padding: '0',
                borderSpacing: '0',
              }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      borderTopLeftRadius: '8px',
                      borderTopRightRadius: '8px',
                      padding: '10px',
                    }}
                  >
                    <img
                      src={imageUrl}
                      alt='Gift Card'
                      style={{
                        width: '100%',
                        maxWidth: '100%',
                        borderRadius: '8px',
                        padding: '0',
                        margin: '0',
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        fontSize: '16px',
                        color: '#696969',
                        fontWeight: '500',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '10px',
                      }}
                    >
                      {userMessage}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td align='center'>
                    <img
                      src='https://b.zmtcdn.com/data/o2_assets/1702a155c29511308b2c287ad96c78121731493783.png'
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        lineHeight: 'normal',
                        marginTop: '5px',
                        marginBottom: '5px',
                        width: '120px',
                      }}
                      alt='---'
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        fontSize: '14px',
                        color: '#696969',
                        fontWeight: '500',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      Gift card amount
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: '10px',
                    }}
                  >
                    <h2
                      style={{
                        fontSize: '24px',
                        fontWeight: '600',
                        margin: '10px 0 10px 0',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0',
                      }}
                    >
                      {formattedAmount}
                    </h2>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        {/* Claim Now Button */}
        <tr>
          <td
            style={{
              textAlign: 'center',
              paddingTop: '20px',
              paddingBottom: '10px',
              fontSize: '16px',
              color: '#FFF',
              fontWeight: 400,
              lineHeight: 'normal',
            }}
            className='esd-text'
          >
            Use this gift card on Zomato orders or 
            {' '}
            <br />
            {' '}
            while paying your bill
            at a restaurant
          </td>
        </tr>
        <tr>
          <td style={{ textAlign: 'center' }}>
            <a
              href={claimLink}
              style={{
                display: 'inline-flex',
                height: '50px',
                padding: '13px 35px',
                alignItems: 'center',
                backgroundColor: '#FFF',
                borderRadius: '12px',
                textDecoration: 'none',
                fontSize: '18px',
                textAlign: 'center',
                fontWeight: '700',
                lineHeight: 'normal',
                letterSpacing: '-0.4px',
                color: 'black',
                marginTop: '20px',
                marginBottom: '20px',
                boxShadow:
                  '0px 16px 16px rgba(54, 54, 54, 0.08), 0px 32px 32px rgba(54, 54, 54, 0.08)',
              }}
            >
              Claim now
            </a>
          </td>
        </tr>
        <tr>
          <td
            style={{ textAlign: 'center', padding: '10px 0 30px 0' }}
            className='esd-text'
            align='center'
          >
            <div
              style={{
                display: 'inline-block',
                width: '35%',
                height: '1px',
                background: 'linear-gradient(to left, white, transparent)',
                verticalAlign: 'middle',
              }}
            >
              {' '}
            </div>
            <span
              style={{
                padding: '0 10px',
                fontSize: '14px',
                fontWeight: 400,
                color: 'white',
                lineHeight: 1,
                fontFamily: "'Our Lexend', Arial, sans-serif",
                textAlign: 'center',
              }}
            >
              OR
            </span>
            <div
              style={{
                display: 'inline-block',
                width: '35%',
                height: '1px',
                background: 'linear-gradient(to right, white, transparent)',
                verticalAlign: 'middle',
              }}
            >
              {' '}
            </div>
          </td>
        </tr>
        {/* Manual Claim Section */}
        <tr>
          <td
            style={{
              backgroundColor: '#EF4F5F',
              padding: '20px',
              marginTop: '25px',
              textAlign: 'left',
              borderRadius: '8px',
            }}
          >
            <h3
              style={{
                color: 'white',
                fontSize: '14px',
                fontWeight: '500',
                display: 'block',
                textAlign: 'center',
              }}
            >
              CLAIM MANUALLY
            </h3>
            <p
              style={{
                color: 'white',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              Gift card code: 
              {' '}
              {gcCode}
            </p>
            <p
              style={{
                color: 'white',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              PIN: 
              {' '}
              {gcPin}
            </p>
            <ol
              style={{
                fontSize: '12px',
                paddingLeft: '20px',
                color: '#FFF',
                listStyle: 'decimal',
              }}
            >
              <li style={{ marginBottom: '10px' }}>
                Go to your profile on the Zomato app
              </li>
              <li style={{ marginBottom: '10px' }}>
                Tap on &apos; Claim Gift Card under &apos;Money&apos; section on
                the side menu
              </li>
              <li style={{ marginBottom: '10px' }}>
                Enter the 16-digit Gift Card code and PIN to claim
              </li>
            </ol>
          </td>
        </tr>
        {/* Footer Section with Stacked Images */}
        <tr>
          <td
            style={{
              textAlign: 'center',
              marginTop: '30px',
            }}
          >
            <table
              style={{
                backgroundColor: '#E23744',
                textAlign: 'center',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <tbody>
                <tr>
                  <td>
                    <img
                      src='https://b.zmtcdn.com/data/o2_assets/1724236122998.png'
                      alt='Zomato'
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        backgroundColor: '#E23744',
                        borderRadius: '12px',
                        lineHeight: 'normal',
                        marginTop: '20px',
                        width: '120px',
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <img
                      src='https://b.zmtcdn.com/data/o2_assets/e103cff94b4a88c4090a471f414e563d1729599424.png'
                      alt='Delivers on Time'
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        backgroundColor: '#E23744',
                        marginBottom: '20px',
                        width: '120px',
                      }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

ZomatoGiftCard.propTypes = {
  imageUrl: PropTypes.string,
  userMessage: PropTypes.string,
  formattedAmount: PropTypes.string,
  companyName: PropTypes.string,
  claimLink: PropTypes.string,
  gcCode: PropTypes.string,
  gcPin: PropTypes.string,
};

ZomatoGiftCard.defaultProps = {
  imageUrl: '',
  userMessage: '',
  formattedAmount: 'xxx',
  companyName: '',
  claimLink: '',
  gcCode: 'xxxx-xxxx-xxxx-xxxx',
  gcPin: 'xxxxxx',
};

export default ZomatoGiftCard;
